'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();var _dec,_desc,_value,_class;function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value}catch(error){reject(error);return}if(info.done){resolve(value)}else{return Promise.resolve(value).then(function(value){step('next',value)},function(err){step('throw',err)})}}return step('next')})}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called')}return call&&(typeof call=='object'||typeof call=='function')?call:self}function _inherits(subClass,superClass){if(typeof superClass!='function'&&superClass!==null){throw new TypeError('Super expression must either be null or a function, not '+typeof superClass)}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key]});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=!0}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=void 0}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null}return desc}

const _=require('pulsar-utils/dist-es6/_');
const BaseController=require('../../../../../dist-es6/client/angularCommon/baseController');
const HandleUncaughtErrors=require('../../../../../dist-es6/client/services/uncaughtErrorHandler').Annotations.HandleUncaughtErrors;
const ModalSubmissionResult=require('../../../../../dist-es6/client/angularCommon/modalSubmissionResult');
const SocketResponse=require('../../../../../dist-es6/client/dtos/socketResponse');
const UserInfo=require('../../../../../dist-es6/client/dtos/userInfo');let

CreateUserModalController=(_dec=








































HandleUncaughtErrors(ModalSubmissionResult.FromError),(_class=function(_BaseController){_inherits(CreateUserModalController,_BaseController);_createClass(CreateUserModalController,null,[{key:'$inject',get:function(){return['$modalInstance','socketService','uiCommandFactory','onUserCreated','uncaughtErrorHandler']}}]);function CreateUserModalController($modalInstance,socketService,uiCommandFactory,onUserCreated,uncaughtErrorHandler){_classCallCheck(this,CreateUserModalController);var _this=_possibleConstructorReturn(this,_BaseController.call(this,uncaughtErrorHandler));_this._socketService=socketService;_this._$modalInstance=$modalInstance;_this._onUserCreated=onUserCreated;_this._createUserCommand=uiCommandFactory.makeForModal($modalInstance,_this._createCurrentUser.bind(_this));_this.emailErrorHandler=_this.emailErrorHandler.bind(_this);_this._firstName=void 0;_this._lastName=void 0;_this._email=void 0;_this._phone=void 0;_this._role='admin';return _this}CreateUserModalController.prototype.onCancel=function onCancel(){this._$modalInstance.dismiss()};CreateUserModalController.prototype.emailErrorHandler=function emailErrorHandler(submissionResult){if(_.exists(submissionResult)){if(submissionResult.status==='HttpError'&&submissionResult.body.httpStatus===409){return`Email address "${this.email}" is already in use.`}}};CreateUserModalController.prototype.
_createCurrentUser=function(){var ref=_asyncToGenerator(function*(){
let createResult=yield this._socketService.sendAndWaitForResponse('CreateUser',{
firstName:this._firstName,
lastName:this._lastName,
email:this._email,
phone:this._phone,
role:this._role});


this._submissionResult=createResult;

if(!SocketResponse.succeeded(createResult)){
return ModalSubmissionResult.KeepOpen;
}

yield this._onUserCreated();

return ModalSubmissionResult.Close(UserInfo.fromJSON(createResult.body));
});function _createCurrentUser(){return ref.apply(this,arguments)}return _createCurrentUser}();_createClass(CreateUserModalController,[{key:'createUserCommand',get:function(){return this._createUserCommand}},{key:'submissionResult',get:function(){return this._submissionResult}},{key:'firstName',get:function()

{
return this._firstName;
},set:function(

firstName){
this._firstName=firstName;
}},{key:'lastName',get:function()

{
return this._lastName;
},set:function(

lastName){
this._lastName=lastName;
}},{key:'email',get:function()

{
return this._email;
},set:function(

email){
this._email=email;
}},{key:'phone',get:function()

{
return this._phone;
},set:function(

phone){
this._phone=phone;
}},{key:'role',get:function()

{
return this._role;
},set:function(

role){
this._role=role;
}}]);return CreateUserModalController}(BaseController),(_applyDecoratedDescriptor(_class.prototype,'_createCurrentUser',[_dec],Object.getOwnPropertyDescriptor(_class.prototype,'_createCurrentUser'),_class.prototype)),_class));


module.exports=CreateUserModalController;
//# sourceMappingURL=createUserModalController.js.map
